// extracted by mini-css-extract-plugin
export default {"slider":"Ushocg3S2fpFGa_dS0d0","thumb":"KJ625T4hbODI_PsDMCww","noValue":"t4aZ_jFUaz69siuyn12H"};